/* unplugin-vue-components disabled */import __unplugin_components_0 from 'E:/new-admin/3.0/ruoyi-vue3-cli/src/components/Pagination/index.vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-61e959c4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "video"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  slot: "tip",
  class: "el-upload__tip"
}, "只能上传视频格式文件", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  slot: "tip",
  class: "el-upload__tip"
}, " 只能上传.jpg,.png,.jpeg格式文件 ", -1));
const _hoisted_4 = {
  class: "dialog-footer"
};
const _hoisted_5 = {
  class: "dialog-footer"
};
import { VideoList, UploadVideo, VideoDelete, TagList, AddTag } from "@/api/video/index";
export default {
  __name: 'index',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const dialogFormVisible = ref(false);
    const dialogtagFormVisible = ref(false);
    const loading = ref(false);
    const btnLoading = ref(false);
    const total = ref(0);
    const formRef = ref();
    const formtagRef = ref();
    const title = ref("新增视频");
    const data = reactive({
      tableData: [],
      TagListData: [],
      selTagListData: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        title: ""
      },
      tagForm: {
        name: ""
      },
      form: {
        title: "",
        msg: "",
        tag_code: [],
        cover: "",
        file: ""
      },
      rules: {
        tag_code: [{
          required: true,
          message: "视频标签不能为空",
          trigger: "change"
        }],
        msg: [{
          required: true,
          message: "视频内容描述不能为空",
          trigger: "change"
        }],
        title: [{
          required: true,
          message: "视频标题不能为空",
          trigger: "change"
        }]
        // cover: [{ required: true, message: "视频封面不能为空", trigger: "change" }],
        // file: [{ required: true, message: "视频地址不能为空", trigger: "change" }],
      }
    });

    const {
      tableData,
      queryParams,
      form,
      rules,
      TagListData,
      tagForm,
      selTagListData
    } = toRefs(data);
    const handleAdd = () => {
      dialogFormVisible.value = true;
    };
    const handleClose = tag => {
      selTagListData.value.splice(selTagListData.value.indexOf(tag), 1);
    };
    const tagChange = tag => {
      const has = selTagListData.value.find(item => item.tag_code == tag.tag_code);
      if (!has) selTagListData.value.push(tag);
    };
    const handleTagAdd = () => {
      dialogtagFormVisible.value = true;
    };
    const cancel = () => {
      dialogFormVisible.value = false;
      reset();
    };
    const cancelTag = () => {
      dialogtagFormVisible.value = false;
      reset();
    };
    const handleQuery = () => {
      queryParams.value.pageNum = 1;
      getList();
    };
    //视频源
    const loadJsonFromFile1 = file => {
      form.value.file = file.raw;
    };
    // 封面
    const loadJsonFromFile2 = file => {
      form.value.cover = file.raw;
    };
    const submit = async formEl => {
      if (!formEl) return;
      await formEl.validate(valid => {
        if (valid) {
          // 新增
          addUser();
        }
      });
    };
    const tagSubmit = async () => {
      if (tagForm.name != "") {
        AddTag(tagForm.value).then(res => {
          dialogtagFormVisible.value = false;
          reset();
          proxy.$modal.msgSuccess("标签新增成功");
          TagListData.value.push({
            tag_code: res.data.code,
            get_tag_info: {
              code: res.data.code,
              name: res.data.name
            },
            code: res.data.code,
            name: res.data.name
          });
        });
      } else {
        proxy.$modal.msgWarning("标签不能为空");
      }
    };

    // 新增
    const addUser = () => {
      form.value.tag_code = [];
      if (selTagListData.value.length > 0) {
        selTagListData.value.forEach(item => {
          form.value.tag_code.push(item.tag_code);
        });
      }
      var formData = new FormData();
      formData.append("file", form.value.file);
      formData.append("cover", form.value.cover);
      formData.append("title", form.value.title);
      formData.append("msg", form.value.msg);
      for (let i = 0; i < form.value.tag_code.length; i++) {
        formData.append(`tag_code[]`, form.value.tag_code[i]);
      }
      UploadVideo(formData).then(() => {
        dialogFormVisible.value = false;
        getList();
        cancel();
        proxy.$modal.msgSuccess("视频新增成功");
      });
    };

    // 关闭弹窗
    const closeDialog = () => {
      dialogFormVisible.value = false;
      reset();
    };

    // 关闭弹窗
    const closeTagDialog = () => {
      dialogtagFormVisible.value = false;
      tagForm.value.name = "";
    };

    // 查询应用列表
    const getList = () => {
      loading.value = true;
      VideoList(queryParams.value).then(res => {
        try {
          tableData.value = res.data.data;
          total.value = res.data.totalCount;
        } catch (error) {}
        loading.value = false;
      });
    };

    // 查询TagList列表
    const getTagList = () => {
      loading.value = true;
      TagList().then(res => {
        try {
          TagListData.value = res.data;
        } catch (error) {}
        loading.value = false;
      });
    };
    const handleDelete = rows => {
      const {
        id
      } = rows;
      proxy.$modal.confirm("是否确认删除?").then(function () {
        return VideoDelete({
          id
        });
      }).then(() => {
        getList();
        proxy.$modal.msgSuccess("删除成功");
      }).catch(err => {
        console.log(err);
        // proxy.$modal.msgError(err.msg);
      });
    };

    // 重置表单
    const reset = () => {
      for (let item in form.value) {
        item = "";
      }
      proxy.$refs?.upload1.clearFiles();
      proxy.$refs?.upload2.clearFiles();
      formRef.value?.resetFields();
    };
    getList();
    getTagList();
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_pagination = __unplugin_components_0;
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        gutter: 2
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: _unref(queryParams),
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
          inline: true,
          ref: "queryParamsRef"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "视频标题",
            prop: "title"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(queryParams).title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(queryParams).title = $event),
              clearable: "",
              placeholder: "请输入视频标题"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              icon: "Search",
              plain: "",
              type: "primary",
              onClick: handleQuery
            }, {
              default: _withCtx(() => [_createTextVNode("搜索")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }), _createVNode(_component_el_row, {
        gutter: 10,
        class: "mb8"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 1.5
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            icon: "Plus",
            plain: "",
            type: "primary",
            onClick: handleAdd
          }, {
            default: _withCtx(() => [_createTextVNode("新增视频")]),
            _: 1
          })]),
          _: 1
        }, 8, ["span"])]),
        _: 1
      }), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        "max-height": 650,
        data: _unref(tableData),
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "title",
          align: "center",
          label: "视频名称"
        }), _createVNode(_component_el_table_column, {
          prop: "msg",
          align: "center",
          label: "视频内容"
        }), _createVNode(_component_el_table_column, {
          prop: "like_num",
          align: "center",
          label: "点赞数"
        }), _createVNode(_component_el_table_column, {
          prop: "file_size_format",
          align: "center",
          label: "文件大小"
        }), _createVNode(_component_el_table_column, {
          prop: "file_url",
          align: "center",
          label: "视频地址"
        }), _createVNode(_component_el_table_column, {
          prop: "cover_url",
          align: "center",
          label: "视频封面"
        }), _createVNode(_component_el_table_column, {
          fixed: "right",
          align: "center",
          label: "操作",
          width: "150"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            link: "",
            type: "danger",
            size: "small",
            onClick: $event => handleDelete(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, _unref(loading)]]), _withDirectives(_createVNode(_component_pagination, {
        total: _unref(total),
        page: _unref(queryParams).pageNum,
        "onUpdate:page": _cache[2] || (_cache[2] = $event => _unref(queryParams).pageNum = $event),
        limit: _unref(queryParams).pageSize,
        "onUpdate:limit": _cache[3] || (_cache[3] = $event => _unref(queryParams).pageSize = $event),
        onPagination: getList
      }, null, 8, ["total", "page", "limit"]), [[_vShow, _unref(total) > 0]]), _createVNode(_component_el_dialog, {
        modelValue: _unref(dialogFormVisible),
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _isRef(dialogFormVisible) ? dialogFormVisible.value = $event : null),
        "before-close": closeDialog,
        title: _unref(title)
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = $event => cancel(_unref(formRef)))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[7] || (_cache[7] = $event => submit(_unref(formRef))),
          loading: _unref(btnLoading)
        }, {
          default: _withCtx(() => [_createTextVNode("提交")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: _unref(form),
          ref_key: "formRef",
          ref: formRef,
          rules: _unref(rules),
          "label-width": "100"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "视频标题",
            prop: "title"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).title,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(form).title = $event),
              placeholder: "请输入视频标题",
              maxlength: "20",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "视频描述",
            prop: "msg"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).msg,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(form).msg = $event),
              placeholder: "请输入视频描述",
              maxlength: "50",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "视频标签"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TagListData), tag => {
              return _openBlock(), _createBlock(_component_el_tag, {
                key: tag.tag_code,
                class: "mx-1",
                "disable-transitions": false,
                onClick: $event => tagChange(tag)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(tag.get_tag_info?.name), 1)]),
                _: 2
              }, 1032, ["onClick"]);
            }), 128)), _createVNode(_component_el_button, {
              class: "button-new-tag ml-1",
              onClick: handleTagAdd
            }, {
              default: _withCtx(() => [_createTextVNode(" 新增标签 ")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "已选择标签"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selTagListData), tag => {
              return _openBlock(), _createBlock(_component_el_tag, {
                key: tag.tag_code,
                class: "mx-1",
                closable: "",
                onClose: $event => handleClose(tag),
                "disable-transitions": false
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(tag.get_tag_info?.name), 1)]),
                _: 2
              }, 1032, ["onClose"]);
            }), 128))]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "视频源",
            prop: "file"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              class: "upload-demo",
              ref: "upload1",
              accept: ".mp4",
              multiple: false,
              limit: 1,
              name: "file",
              action: "",
              "file-list": _ctx.fileList,
              "on-change": loadJsonFromFile1,
              "auto-upload": false
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                slot: "trigger",
                size: "small",
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode("选取文件")]),
                _: 1
              }), _hoisted_2]),
              _: 1
            }, 8, ["file-list"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "视频封面",
            prop: "cover"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              class: "upload-demo",
              ref: "upload2",
              action: "",
              accept: ".jpg,.png,.jpeg",
              multiple: false,
              limit: 1,
              name: "cover",
              "file-list": _ctx.fileList,
              "on-change": loadJsonFromFile2,
              "auto-upload": false,
              "list-type": "picture"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                slot: "trigger",
                size: "small",
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode("选取图片")]),
                _: 1
              }), _hoisted_3]),
              _: 1
            }, 8, ["file-list"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(dialogtagFormVisible),
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _isRef(dialogtagFormVisible) ? dialogtagFormVisible.value = $event : null),
        "before-close": closeTagDialog,
        title: "新增标签"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = $event => cancelTag())
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[11] || (_cache[11] = $event => tagSubmit()),
          loading: _unref(btnLoading)
        }, {
          default: _withCtx(() => [_createTextVNode("提交")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: _unref(tagForm),
          ref_key: "formtagRef",
          ref: formtagRef,
          "label-width": "80"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "标签名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(tagForm).name,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(tagForm).name = $event),
              placeholder: "请输入标签名称",
              maxlength: "20",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};